"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The distribution's own drawing: a row of bars over a baseline, and the axis
 * under it.
 *
 * A column is a full-height hover target rather than the bar itself, so a
 * short bar is as easy to point at as a tall one, and every bar keeps a
 * hairline even at a count of zero — the axis then reads as a continuous range
 * with gaps in it rather than as missing.
 */
const styles = exports.styles = {
  chartHolder: {
    position: "x1n2onr6",
    $$css: true
  },
  histogram: {
    display: "x78zum5",
    alignItems: "xuk3077",
    gap: "x195vfkc",
    rowGap: null,
    columnGap: null,
    height: "x1u5z0ei",
    marginTop: "xj1urod",
    width: "xh8yej3",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    $$css: true
  },
  histogramColumn: {
    display: "x78zum5",
    alignItems: "xuk3077",
    flexGrow: "x1iyjqo2",
    height: "x5yr21d",
    minWidth: "xeuugli",
    cursor: "xsid9ct",
    $$css: true
  },
  histogramBar: {
    width: "xh8yej3",
    backgroundColor: "x1c1r1s3",
    opacity: "x18km98s",
    transitionProperty: "x1humd01",
    transitionDuration: "xbb3pvg",
    transitionTimingFunction: "x9lcvmn",
    borderTopLeftRadius: "xdocmp1",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderTopRightRadius: "xja2y4p",
    $$css: true
  },
  histogramBarActive: {
    opacity: "x1hc1fzr",
    $$css: true
  },
  axis: {
    display: "x78zum5",
    justifyContent: "x1qughib",
    paddingTop: "x1iul6r4",
    $$css: true
  }
};